<app-header [forceLightBackground]="true"></app-header>
<div class="profile-page">
  <div class="profile-page--layout">
    <app-provider-sidebar class="profile-page--sidebar"></app-provider-sidebar>
    <div class="profile-page--content">
      <app-page-header></app-page-header>
      
      <div class="profile-container">
        <app-profile></app-profile>
      </div>
    </div>
  </div>
</div>



